import React, {useEffect, useState} from "react";
import { Link, useLocation } from "react-router-dom";
import mainMenus from "../config/menuConfig";
import assets from "../assets/imgs";
import {useUser, UserProvider} from "../context/UserContext";

function Header() {
  const location = useLocation();
  const {authority} = useUser();  
  // const navigate = useNavigate();


  //header extra 함수 실행 전달 부부
  const [triggerNewEntry, setTriggerNewEntry] = useState(() => () => {});
  const [triggerNewEntry2, setTriggerNewEntry2] = useState(() => () => {});
  useEffect(() => {
    // console.log("🚀 location.pathname", location.pathname);
    const eventHandler = (eventName) => () => {
      console.log(`🚀 ${eventName} 버튼 클릭 이벤트 감지됨!`);
      window.dispatchEvent(new Event(eventName));
    };

    // ✅ 현재 페이지에 따라 다른 이벤트를 실행하도록 설정
    const getEventForPath = (path) => {
      // console.log("🚀 path", path);
      switch (path) {
        case "/my_page/company_manage": return eventHandler("newMypageEntry_ManagerManage");

        case "/performance": return eventHandler("newPerformanceEntry_sales");
        case "/performance/invest": return eventHandler("newPerformanceEntry_invests");
        case "/performance/support": return eventHandler("newPerformanceEntry_supportProjects");
        case "/performance/intellectual": return eventHandler("newPerformanceEntry_intellectualProperties");
        case "/performance/team": return eventHandler("newPerformanceEntry_employments");
        case "/performance/prize": return eventHandler("newPerformanceEntry_prizes");

        case "/board": return eventHandler("newBoardEntry_Announce");
        case "/board/networking": return eventHandler("newBoardEntry_Network");
        case "/board/share": return eventHandler("newBoardEntry_Info");
        // case "invest": return eventHandler("newPerformanceEntry_performanceInvest");
        // case "support": return eventHandler("newPerformanceEntry_performanceSupport");
        // case "intellectual": return eventHandler("newPerformanceEntry_performanceIntellectual");
        // case "team": return eventHandler("newPerformanceEntry_performanceTeam");
        default: return () => {};
      }
    };

    setTriggerNewEntry(() => getEventForPath(location.pathname));


    const getEventForPath2 = (path) => {
      console.log("🚀 path", path);
      switch (path) {
        case "/performance": return eventHandler("newPerformanceEntry_sales2");
        case "/performance/invest": return eventHandler("newPerformanceEntry_invests2");
        case "/performance/support": return eventHandler("newPerformanceEntry_supportProjects2");
        case "/performance/intellectual": return eventHandler("newPerformanceEntry_intellectualProperties2");
        case "/performance/team": return eventHandler("newPerformanceEntry_employments2");
        case "/performance/prize": return eventHandler("newPerformanceEntry_prizes2");

        default: return () => {};
      }
    };

    setTriggerNewEntry2(() => getEventForPath2(location.pathname));
  }, [location]);


  //2단계 메뉴 active
  const isActive = (path) => location.pathname === path;  

  //2단계 메뉴 보이기 selection
  // 현재 경로의 첫 번째 단계 추출
  const getPathSegment = (pathname) => pathname.split("/")[1];
  const getFirstPathSegment = (pathname) => pathname.split("/")[1];
  const getSecondPathSegment = (pathname) => pathname.split("/")[2];
  // 현재 경로의 첫 번째 단계
  const currentFirstPath = getFirstPathSegment(location.pathname);  
  const currentSecondPath = getSecondPathSegment(location.pathname) || "";
  
  return (
    <header style={styles.header}>
      <nav>
        <ul style={styles.navList}>
          {mainMenus
            .filter(({ path }) => getFirstPathSegment(path) === currentFirstPath) // 첫 번째 단계가 같은 메뉴만 필터링
            .flatMap(({ lowerMenu }) => lowerMenu || []) // 하위 메뉴만 가져오기
            .filter(({authority : menuAuthority, variants})=>{
              // 하위 메뉴 권한 체크: 직접 authority 또는 variants 확인
              if (menuAuthority) {
                return menuAuthority.includes(authority);
              }
              if (variants) {
                return variants.some((variant) => variant.authority.includes(authority));
              }
              return true; // authority가 없는 경우 기본적으로 표시
            })
            .map(({ label: subLabel, path: subPath, variants, disabled }) => {
              const filteredVariants = variants?.filter((variant) => variant.authority.includes(authority)) || [];
              // variants 중 필터링된 데이터에서 label이 있는 첫 번째 항목 찾기
              const variantLabel = filteredVariants.find((variant) => variant.label)?.label;
              const displayLabel = variantLabel || subLabel; // variantLabel이 있으면 사용, 없으면 기존 subLabel 사용

              const fullPath = `${currentFirstPath}${subPath}`.replace(/\/+/g, "/").replace(/\/$/, "");
              const isDisabled = disabled;

              return(
                <li key={subPath} style={styles.subMenuItem}>
                  <Link
                    to={fullPath}
                    style={{
                      ...(getPathSegment(subPath) == currentSecondPath ? styles.subMenuLinkAct : styles.subMenuLink),
                      ...(isDisabled ? styles.disabledSubMenu : {})
                    }}
                    onClick={(e) => {
                      if (isDisabled) {
                        e.preventDefault();
                      }
                    }}
                  >
                    {displayLabel}
                  </Link>
                </li>
              );
          })}
        </ul>
      </nav>
      <div style={styles.extraSection}>
        <HeaderExtra2
          currentFirstPath={currentFirstPath}
          currentSecondPath={currentSecondPath}
          triggerNewEntry ={triggerNewEntry2}
          />
        <HeaderExtra
          currentFirstPath={currentFirstPath}
          currentSecondPath={currentSecondPath}
          triggerNewEntry ={triggerNewEntry}
          />
        <ChatIcon/>
      </div>
      
    </header>
  );
}

const HeaderExtra = ({currentFirstPath, currentSecondPath, triggerNewEntry}) =>{
  const {authority} = useUser();  

  console.log("🟠 [HeaderExtra] 버튼 렌더링됨, triggerNewEntry 연결됨");
  const firstMenu = mainMenus.find(menu => menu.path === `/${currentFirstPath}`);

  if (!firstMenu) return null;

  //  하위 메뉴가 있으면 해당 extraContent 렌더링
  const secondMenu = firstMenu.lowerMenu?.find(
    sub => sub.path === `/${currentSecondPath}`
  );
  if (!secondMenu) return null;

  // ✅ `headerExtra`가 `variants` 안에 있는 경우 처리
  let headerExtras = [];

  if (secondMenu.headerExtra) {
    headerExtras.push(secondMenu.headerExtra);
  }

  if (secondMenu.variants) {
    secondMenu.variants.forEach(variant => {
      if (variant.authority.includes(authority) && variant.headerExtra) {
        headerExtras.push(variant.headerExtra);
      }
    });
  }

  if (headerExtras.length === 0) return null;

  return (
    <div>
      {headerExtras.map((extraComponent, index) => (
        <div key={index} onClick={() => triggerNewEntry(extraComponent.props.eventName || `customEvent_${index}`)}>
          {React.cloneElement(extraComponent)}
        </div>
      ))}
    </div>
  );

}
const HeaderExtra2 = ({currentFirstPath, currentSecondPath, triggerNewEntry}) =>{
  const {authority} = useUser();  

  console.log("🟠 [HeaderExtra] 버튼 렌더링됨, triggerNewEntry 연결됨");
  const firstMenu = mainMenus.find(menu => menu.path === `/${currentFirstPath}`);

  if (!firstMenu) return null;

  //  하위 메뉴가 있으면 해당 extraContent 렌더링
  const secondMenu = firstMenu.lowerMenu?.find(
    sub => sub.path === `/${currentSecondPath}`
  );
  if (!secondMenu) return null;

  // ✅ `headerExtra`가 `variants` 안에 있는 경우 처리
  let headerExtras = [];

  if (secondMenu.headerExtra2) {
    headerExtras.push(secondMenu.headerExtra2);
  }

  if (secondMenu.variants) {
    secondMenu.variants.forEach(variant => {
      if (variant.authority.includes(authority) && variant.headerExtra2) {
        headerExtras.push(variant.headerExtra2);
      }
    });
  }
  console.log('header extra:', headerExtras.length);

  if (headerExtras.length === 0) return null;

  return (
    <div>
      {headerExtras.map((extraComponent, index) => (
        <div key={index} onClick={() => triggerNewEntry(extraComponent.props.eventName || `customEvent_${index}`)}>
          {React.cloneElement(extraComponent)}
        </div>
      ))}
    </div>
  );

}

const ChatIcon= ({newChat})=>{
  const chatExist = newChat ?? true;
  return(
    <div style={styles.chatIcon}>
      <assets.icons.chat_icon />
      {chatExist && (
        <div style={styles.newChat}></div>
      )}
    </div>
  );
};

const styles = {
  header: { backgroundColor: "white", padding: "11px 40px 11px 30px", display: "flex",
    alignItems:"center", justifyContent: "space-between"
  },
  navList: { display: "flex", listStyle: "none", justifyContent: "flex-start", gap: "28px" },
  subMenuItem: {display: "flex", alignItems: "center",},
  subMenuLink: {
    color: "var(--grayscale_60)", fontSize: "16px", fontWeight: "600", 
  },
  extraSection:{
    display:"flex", alignItems:"center", gap: "24px",
  },
  chatIcon:{
    border: "1px solid var(--grayscale_40)",
    backgroundColor: "var(--grayscale_20)",
    borderRadius: "50%",
    width: "44px",
    height: "44px",
    display:"flex", alignItems:"center", justifyContent: "center",
    position: "relative",
    cursor: "pointer",
  },
  newChat:{
    width: "6px", height: "6px",
    borderRadius: "50%",
    backgroundColor: "var(--primary-crimson_30)",
    position: "absolute", right: "11px", top: "11px"
  },
  subMenuLinkAct: {
    color: "var(--primary-crimson_60)", fontSize: "18px", fontWeight: "700",
  },
  disabledSubMenu: {
    opacity: 0.5,
    cursor: "not-allowed",
    pointerEvents: "none",
  }
};

export default Header;